export const LOAD_USERS = "LOAD_USERS";
export const SET_USERS = "SET_USERS";
export const SET_GROUPS = "SET_GROUPS";
export const SELECT_TAB = "SELECT_TAB";